export interface Work {
  id: number;
  logo: string;
  title: string;
  image: string;
  url: string;
  tags: string[];
}

export const worksData: Work[] = [
    {
      id: 1,
      logo: '/images/logo.png',
      title: 'ｔｏｃｏｔｏｎ様公式サイト',
      image: '/images/img_works001.jpg',
      url: 'https://tocoton-tokyo.com/',
      tags: ['HTML', 'SCSS', 'JavaScript', 'PHP'],
    },
    {
      id: 2,
      logo: '/images/logo.png',
      title: '仮想スイーツ店公式サイト（サンプル）',
      image: '/images/img_works002.jpg',
      url: 'https://webwisewords.net//works/sweet_delight/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    {
      id: 3,
      logo: '/images/logo.png',
      title: '仮想企業のLP',
      image: '/images/img_works003.jpg',
      url: 'https://webwisewords.net/works/The_Company/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    {
      id: 4,
      logo: '/images/logo.png',
      title: 'sobolon様(デイトラ制作物)',
      image: '/images/img_works004.jpg',
      url: 'https://webwisewords.net/works/sobolon/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    {
      id: 5,
      logo: '/images/logo.png',
      title: '仮想企業のLP',
      image: '/images/img_works005.jpg',
      url: 'https://webwisewords.net/works/Sample_Corp/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    {
      id: 6,
      logo: '/images/logo.png',
      title: '仮想企業のWebサイト（WordPress）',
      image: '/images/img_works006.jpg',
      url: 'https://totonou-code.com/pacificmall/',
      tags: ['HTML', 'CSS', 'JavaScript', 'PHP', 'WordPress'],
    },
    {
      id: 7,
      logo: '/images/logo.png',
      title: 'オリジナルテーマブログ（WordPress）',
      image: '/images/img_works007.jpg',
      url: 'https://totonou-code.com/TF-30/',
      tags: ['HTML', 'SCSS', 'JavaScript', 'PHP', 'WordPress'],
    },
    {
      id: 8,
      logo: '/images/logo.png',
      title: '仮想企業 + アプリe-tigaのLP',
      image: '/images/img_works008.jpg',
      url: 'https://webwisewords.net/works/e-tiga/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    {
      id: 9,
      logo: '/images/logo.png',
      title: '仮想アプリOHAのLP',
      image: '/images/img_works009.jpg',
      url: 'https://webwisewords.net/works/oha/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    {
      id: 10,
      logo: '/images/logo.png',
      title: '喫茶店WEB_CAFEのHP',
      image: '/images/img_works010.jpg',
      url: 'https://webwisewords.net/works/WEB_CAFE/index.html',
      tags: ['HTML', 'SCSS', 'JavaScript'],
    },
    // {
    //   id: 11,
    //   logo: '/images/logo.png',
    //   title: '初めて制作したLP',
    //   image: '/images/img_works999.jpg',
    //   url: 'https://webwisewords.net/works/first_LP/index.html',
    //   tags: ['HTML', 'CSS', 'JavaScript'],
    // },
  ];